module.exports = __webpack_public_path__ + "img/check-mark-grey.a8507559.svg";